export interface HealthReportEntry {
  data: { [key: string]: any };
  description: string;
  duration: string;
  status: HealthStatus;
  tags: string[];
}

export enum HealthStatus {
  Unhealthy,
  Degraded,
  Healthy,
}

export interface NamedHealthReport {
  name: string;
  status: HealthStatus;
  totalDuration: string;
  entries: { [key: string]: HealthReportEntry };
}
